export default __webpack_public_path__ + "static/bayareasidingwindows-b13a7ab9145df0a023f28bda26bc851c.webp";